import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import OrganizerFileIcon from "../../modules/organizer/view/OrganizerFileIcon";

/**
 * DocumentTypeItem: (props) => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * List item component rendering a specific document type
 * with an icon, title and a description, for use in a action list.
 *
 * @param {*} props
 */
const DocumentTypeItem = props => (
  <div
    className={`ax-document-type-item type-${props.documentType}`}
    onClick={() => props.documentTypeSelected(props.documentType)}
    role="presentation"
  >
    <div className="icon">
      {/**
       * Returns the file type icon with width 24px (@2x: 48px)
       */}
      <OrganizerFileIcon documentType={props.documentType} size={24} />
    </div>
    <div className="depiction">
      {/**
       * Returns the localized file type name and description as provided
       * in the i18n files.
       */}
      <b>
        <FormattedMessage id={`files.types.${props.documentType}.title`} />
      </b>
      <p>
        <FormattedMessage
          id={`files.types.${props.documentType}.description`}
        />
      </p>
    </div>
  </div>
);

DocumentTypeItem.propTypes = {
  /**
   * documentType: String
   * File type identifier (e.g. "com.saliorel.edu.simpletext")
   */
  documentType: PropTypes.string.isRequired,

  /**
   * documentTypeSelected: (selectedDocumentType) => ()
   * Fired when this item is clicked / selected.
   */
  documentTypeSelected: PropTypes.func.isRequired
};

export default DocumentTypeItem;



// WEBPACK FOOTER //
// ./src/components/contextbar/DocumentTypeItem.js